import { string } from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Icon } from '@chaser/components';
import style from './InfoLink.module.scss';

const InfoLink = ({ to, label, className }) => {
  return (
    <a
      href={to}
      tabIndex={0}
      className={cx(className, style.link)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
    >
      <Icon name="help" />
    </a>
  );
};

InfoLink.propTypes = {
  to: string,
  label: string,
  className: string,
};

export default InfoLink;
